import { useEffect, useState } from "react";
import ProductCard from "../Product/ProductCard/newProductCard";
import headingImage from "./assets/headings-style.png";
import "./HomeProductSection.css";

import {
  Grid,
  Typography,
  CircularProgress,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../config/api";

const HomeProductSectionAll = ({ section, paragraph }) => {
  const [products, setProducts] = useState([]);
  const [isLoaderOpen, setIsLoaderOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setIsLoaderOpen(true);

        const res = await fetch(
          `${API_BASE_URL}/api/products?color=&size=&minPrice=0&maxPrice=10000&minDiscount=0&category=all&stock=null&sort=price_low&pageNumber=1&pageSize=50`
        );

        const data = await res.json();

        // Filter specific products
        const filtered = data.content.filter(
          (item) =>
            item.title.toLowerCase().includes("cup") ||
            item.title.toLowerCase().includes("cone")
        );

        setProducts(filtered);
        setIsLoaderOpen(false);
      } catch (error) {
        console.error("Failed to fetch products:", error);
        setIsLoaderOpen(false);
      }
    };

    fetchProducts();
  }, []);

  return (
    <div className="relative mt-10 px-4 sm:px-6 lg:px-10">
      {/* Heading */}
      <div className="text-center mb-4">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold">{section}</h2>
        <span className="block text-gray-500 mt-2 text-base sm:text-lg">
          {paragraph}
        </span>
      </div>

      {/* Product Cards */}
      {isLoaderOpen ? (
        <div className="flex justify-center my-10">
          <CircularProgress />
        </div>
      ) : products.length > 0 ? (
        <Grid container spacing={2} justifyContent="center">
            {products.slice(0, 4).map((item) => (
         <Grid
  item
  key={item.id}
  xs={6}
  sm={6}
  md={4}
  lg={3}
  sx={{
    height: "auto", // Let height adjust to content
    "@media (min-width:805px) and (max-width:900px)": {
      height: "auto",
    },
    "@media (min-width:1560px) and (max-width:1900px)": {
      height: "auto",
    },
  }}
>
  <ProductCard product={item} />
</Grid>

                    ))}
        </Grid>
      ) : (
        <Typography variant="body1" align="center" mt={3}>
          No matching products found.
        </Typography>
      )}

      {/* View More Button */}
      <div className="flex justify-center mt-6">
        <Button
          variant="contained"
          onClick={() => navigate("/product/econirmit/all")}
          sx={{
            backgroundColor: "black",
            borderRadius: "20px",
            padding: "10px 48px",
            color: "white",
            fontWeight: "bold",
            "&:hover": {
              backgroundColor: "#333",
            },
          }}
        >
          View More
        </Button>
      </div>
    </div>
  );
};

export default HomeProductSectionAll;
